import db from "../../database";
import store from "../../store/index";
import moment from "moment";
import * as helper from "../../helper";
import * as msg from "../../message";

export const checkProductInCart = (data) => {
  let existsItem = store.state.billing.billing.cart.data.filter((item) => {
    if (
      data.hasOwnProperty("selected_batch_price") &&
      parseFloat(data.batch_id) != 0
    ) {
      return (
        item.product_data.barcode == data.barcode &&
        parseFloat(item.product_data.unit_mrp) ==
          parseFloat(data.selected_batch_price)
      );
    } else if (
      data.hasOwnProperty("selected_serial_price") &&
      parseFloat(data.serial_id) != 0
    ) {
      return (
        item.product_data.barcode == data.barcode &&
        parseFloat(item.product_data.unit_mrp) ==
          parseFloat(data.selected_serial_price)
      );
    } else {
      return data.change_mrp == ""
        ? item.product_data.barcode == data.barcode
        : item.product_data.barcode == data.barcode &&
            item.product_data.unit_mrp == data.change_mrp;
    }
  });

  if (existsItem.length > 0) {
    if (existsItem[0].product_data.weight_flag == false)
      data.qty = parseInt(existsItem[0].qty) + 1;
    updateProduct(data);
  } else addToCart(data);
};

export const addToCart = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Add to cart");
    let response = {
      data: {},
    };
    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }
    let session_id = 0;
    let manual_discount_basis = "";
    let manual_discount_factor = "";
    let cal_disc_total = 0;
    let insertData = {
      v_id: data.v_id,
      store_id: data.store_id,
      user_id: data.c_id,
      barcode: data.barcode,
      sku: 0,
      item_name: "",
      qty: 1,
      unit_mrp: 0,
      unit_rsp: 0,
      subtotal: 0,
      total: 0,
      tax: 0,
      discount: "0.00",
      md_discount: 0,
      status: "process",
      vu_id: data.vu_id,
      date: moment(new Date()).format("YYYY-MM-DD"),
      time: moment(new Date()).format("HH:mm:ss"),
      weight_flag: false,
      tax_data: 0,
      batch_id: data.batch_id,
      serial_id: data.serial_id,
    };

    db.transaction("rw", db.cart, db.products, db.session, async () => {
      await db.cart
        .where("[store_id+vu_id+v_id+user_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
          parseInt(data.c_id),
        ])
        .and((filter) => {
          return filter.status == "process";
        })
        .first((item) => {
          if (item != undefined) {
            manual_discount_factor = item.manual_discount_factor;
            manual_discount_basis = item.manual_discount_basis;
          }
        });
      await db.session
        .where("vu_id")
        .equals(parseInt(data.vu_id))
        .and((filter) => {
          return filter.closing_balance == "" || filter.closing_balance == null;
        })
        .first((item) => {
          if (item == undefined) {
            session_id = 0;
          } else {
            session_id = item.id;
          }
        });
      await db.products
        .where("barcode")
        .equals(data.barcode.toString())
        .first()
        .then(async (item) => {
          if (item == undefined) {
            return Promise.resolve(response);
          }
          if (item.weight_flag) {
            db.cart
              .where("barcode")
              .equals(data.barcode.toString())
              .and((filter) => {
                return filter.unit_mrp == data.unit_mrp;
              })
              .delete();
            insertData.qty = data.qty;
            if (
              data.hasOwnProperty("selected_batch_price") &&
              parseInt(data.batch_id) != 0
            ) {
              insertData.subtotal = parseFloat(
                data.selected_batch_price * data.qty
              ).toFixed(2);
              insertData.total = parseFloat(
                data.selected_batch_price * data.qty
              ).toFixed(2);
            } else if (
              data.hasOwnProperty("selected_serial_price") &&
              parseInt(data.serial_id) != 0
            ) {
              insertData.subtotal = parseFloat(
                data.selected_serial_price * data.qty
              ).toFixed(2);
              insertData.total = parseFloat(
                data.selected_serial_price * data.qty
              ).toFixed(2);
            } else {
              insertData.subtotal =
                data.change_mrp == ""
                  ? (item.mrp * data.qty).toFixed(2)
                  : (data.change_mrp * data.qty).toFixed(2);
              insertData.total =
                data.change_mrp == ""
                  ? (item.mrp * data.qty).toFixed(2)
                  : (data.change_mrp * data.qty).toFixed(2);
            }
          } else {
            if (
              data.hasOwnProperty("selected_batch_price") &&
              parseInt(data.batch_id) != 0
            ) {
              insertData.subtotal = parseFloat(
                data.selected_batch_price
              ).toFixed(2);
              insertData.total = parseFloat(data.selected_batch_price).toFixed(
                2
              );
            } else if (
              data.hasOwnProperty("selected_serial_price") &&
              parseInt(data.serial_id) != 0
            ) {
              insertData.subtotal = parseFloat(
                data.selected_serial_price
              ).toFixed(2);
              insertData.total = parseFloat(data.selected_serial_price).toFixed(
                2
              );
            } else {
              insertData.subtotal =
                data.change_mrp == "" ? item.mrp : data.change_mrp;
              insertData.total =
                data.change_mrp == "" ? item.mrp : data.change_mrp;
            }
          }
          insertData.sku = item.sku;
          insertData.multiple_price = item.multiple_price;
          insertData.uom = item.uom;
          insertData.item_name = item.name;
          if (
            data.hasOwnProperty("selected_batch_price") &&
            parseInt(data.batch_id) != 0
          ) {
            insertData.unit_mrp = parseFloat(data.selected_batch_price).toFixed(
              2
            );
          } else if (
            data.hasOwnProperty("selected_serial_price") &&
            parseInt(data.serial_id) != 0
          ) {
            insertData.unit_mrp = parseFloat(
              data.selected_serial_price
            ).toFixed(2);
          } else {
            insertData.unit_mrp =
              data.change_mrp == "" ? item.mrp : data.change_mrp;
          }
          insertData.unit_rsp = item.rsp;
          insertData.weight_flag = item.weight_flag;
          insertData.terminal_id = store.state.system.settings.terminal_id;
          insertData.session_id = session_id;
          insertData.sync = 0;
          insertData.manual_discount_factor = manual_discount_factor;
          insertData.manual_discount_basis = manual_discount_basis;
          const tax_calculation = await taxCalculation(
            item.tax_details,
            insertData
          );
          insertData.tax = tax_calculation.tax;
          insertData.tax_data = tax_calculation;
          if (insertData.tax_data.tax_type == "EXC")
            insertData.total = (
              Math.round(100 * insertData.total) / 100 +
              Math.round(100 * insertData.tax) / 100
            ).toFixed(2);
          db.cart.put(insertData);
        });

      if (manual_discount_basis != "" && manual_discount_factor != "") {
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            if (item != undefined && item.manual_discount_basis != "") {
              cal_disc_total += parseFloat(item.subtotal);
            }
          });
      }

      if (cal_disc_total != 0) {
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            if (
              item.manual_discount_basis == "P" &&
              item.manual_discount_factor != ""
            ) {
              item.discount =
                parseFloat(item.discount) - parseFloat(item.md_discount);
              getManualDiscountByPercent(item);
            } else if (
              item.manual_discount_basis == "A" &&
              item.manual_discount_factor != ""
            ) {
              item.discount =
                parseFloat(item.discount) - parseFloat(item.md_discount);
              getManualDiscountByAmount(item, cal_disc_total);
            }
          });
      }

      response.data = {
        message: "Product was successfully added to your cart.",
        status: "add_to_cart",
        total_amount: "0",
        total_qty: 0,
      };
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "product_details",
          log: { name: err.name, message: err.message, barcode: data.barcode },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const cartDetails = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Cart Details");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let productData = data.data.data;
      let requestData = JSON.parse(data.config.data);
      // let terminal_id = store.state.system.settings.terminal_id;

      db.transaction("rw", db.cart, db.products, async () => {
        if (productData.length == 0) {
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(requestData.store_id),
              parseInt(requestData.vu_id),
              parseInt(requestData.v_id),
              parseInt(requestData.c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .delete();
        } else {
          productData.map(async (item) => {
            let product_tax_data = JSON.parse(item.product_data.tdata);
            let product_sku = JSON.parse(item.product_data.tdata).barcode;
            let insertData = {};
            await db.cart
              .where("[store_id+vu_id+v_id+user_id]")
              .equals([
                parseInt(requestData.store_id),
                parseInt(requestData.vu_id),
                parseInt(requestData.v_id),
                parseInt(requestData.c_id),
              ])
              .and((filter) => {
                return (
                  filter.barcode == item.product_data.barcode &&
                  filter.unit_mrp == item.product_data.unit_mrp
                );
              })
              .first(async (prod) => {
                insertData = {
                  v_id: requestData.v_id,
                  store_id: requestData.store_id,
                  user_id: requestData.c_id,
                  barcode: item.product_data.barcode,
                  qty: item.qty,
                  unit_mrp: item.product_data.unit_mrp,
                  unit_rsp: item.product_data.r_price,
                  subtotal:
                    parseFloat(item.product_data.unit_mrp) *
                    parseFloat(item.qty),
                  total: item.amount,
                  tax: parseFloat(item.tax_amount),
                  discount: item.product_data.discount,
                  md_discount:
                    item.product_data.manual_discount.mdiscount == ""
                      ? 0
                      : item.product_data.manual_discount.mdiscount,
                  status: "process",
                  vu_id: requestData.vu_id,
                  date: moment(new Date()).format("YYYY-MM-DD"),
                  time: moment(new Date()).format("HH:mm:ss"),
                  multiple_price: item.product_data.multiple_mrp,
                  tax_data: product_tax_data,
                  sku: product_sku,
                  uom: item.product_data.uom,
                  item_name: item.product_data.p_name,
                  weight_flag: item.product_data.weight_flag,
                  terminal_id: store.state.system.settings.terminal_id,
                  batch_id: item.product_data.hasOwnProperty("batch_id")
                    ? parseInt(item.product_data.batch_id)
                    : 0,
                  serial_id: item.product_data.hasOwnProperty("serial_id")
                    ? parseInt(item.product_data.serial_id)
                    : 0,
                  sync: 0,
                  online_cart_id: item.cart_id,
                  session_id: store.state.sessions.session.id,
                  manual_discount_basis:
                    item.product_data.manual_discount.basis,
                  manual_discount_factor:
                    item.product_data.manual_discount.factor,
                };
                if (prod == undefined || prod.status == "hold") {
                  await db.cart.put(insertData);
                } else if (prod.status == "process") {
                  await db.cart.delete(parseInt(prod.id));
                  await db.cart.put(insertData);
                }
              });
          });
        }
      });
      return Promise.resolve(response);
    }

    let productData = [];
    let bill_summary = [];
    let tax_inc = 0.0;
    let tax_exc = 0.0;
    let cart_qty_total = 0;
    let carry_bag_qty_total = "0";
    let bill_buster_discount = "0.00";
    let discount = "0.00";
    // let order_id = 0;
    let hold_bill_count = 0;
    // let store_credit = 0.0;
    let sub_total = 0.0;
    let tax_total = 0.0;
    let total = 0.0;
    let carry_bags = store.state.system.settings.cart.carry_bag.data;
    let dispCarryBags = [];
    // let cal_disc_total = 0;
    let manual_discount = 0;

    db.transaction("rw", db.cart, async () => {
      await db.cart
        .where("[store_id+vu_id+v_id+user_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
          parseInt(data.c_id),
        ])
        .reverse()
        .and((filter) => {
          return filter.status == "process";
        })
        .each((item) => {
          productData.push({
            cart_id: item.id,
            product_data: {
              barcode: item.barcode,
              p_name: item.item_name,
              r_price: item.subtotal,
              s_price: item.total,
              discount: item.discount,
              unit_price: item.unit_mrp,
              unit_mrp: item.unit_mrp,
              current_stock: 50,
              batch: [],
              uom: item.uom,
              weight_flag: item.weight_flag,
              offer: "No",
              offer_data: {
                applied_offers: [],
                available_offers: [],
              },
              multiple_price_flag: false,
              multiple_mrp: item.multiple_price,
              images: "",
              batch_id: item.batch_id,
              serial_id: item.serial_id,
              tdata: JSON.stringify(item.tax_data),
            },
            amount: item.total,
            tax_amount: item.tax,
            qty: item.qty,
          });

          item.weight_flag == true
            ? (cart_qty_total += 1)
            : (cart_qty_total += parseFloat(item.qty));
          sub_total += parseFloat(item.subtotal);
          tax_exc += item.tax_data.tax_type == "EXC" ? item.tax : 0;
          tax_inc += item.tax_data.tax_type == "INC" ? item.tax : 0;
          tax_total += parseFloat(item.tax);
          total += parseFloat(item.total);
          manual_discount += parseFloat(item.md_discount);
        });

      let man_disc = {
        name: "manual_discount",
        display_text: "Manual Discount",
        item_type: "",
        type: [
          {
            name: "item_level",
            value: "0.00",
          },
          {
            name: "bill_level",
            value: (Math.round(100 * manual_discount) / 100).toFixed(2),
          },
        ],
        value: (Math.round(100 * manual_discount) / 100).toFixed(2),
        sign: "-",
      };

      let summary_inc = {
        name: "tax_inc",
        display_text: "Tax Total (Included)",
        item_type: "",
        value: (Math.round(100 * tax_inc) / 100).toFixed(2),
        sign: "",
      };

      let summary_exc = {
        name: "tax_exc",
        display_text: "Tax Total (Excluded)",
        item_type: "",
        value: (Math.round(100 * tax_exc) / 100).toFixed(2),
        sign: "",
      };

      bill_summary.push(
        {
          name: "sub_total",
          display_text: "Sub Total",
          item_type: "",
          value: (
            Math.round(100 * sub_total) / 100 -
            Math.round(100 * tax_inc) / 100
          ).toFixed(2),
          sign: "",
        },
        {
          name: "total",
          display_text: "Total",
          item_type: "",
          value: (Math.round(100 * total) / 100).toFixed(2),
          sign: "",
        }
      );

      if (tax_inc != 0) {
        bill_summary.splice(1, 0, summary_inc);
      }

      if (tax_exc != 0) {
        bill_summary.splice(1, 0, summary_exc);
      }

      if (manual_discount != 0) {
        bill_summary.splice(1, 0, man_disc);
      }

      carry_bags.map(async (item) => {
        await db.cart.get({ barcode: item }, (carry_bag) => {
          let carryData = {};
          if (carry_bag != undefined) {
            carryData.Name = carry_bag.item_name;
            carryData.BAG_ID = carry_bag.barcode;
            carryData.Price = carry_bag.unit_mrp;
            carryData.Qty = carry_bag.qty;
            carry_bag_qty_total =
              parseInt(carry_bag_qty_total) + parseInt(carry_bag.qty);
          }
          dispCarryBags.push(carryData);
        });
      });
    })
      .then(async () => {
        await db.order.each((item) => {
          if (item.status == "hold") {
            hold_bill_count += 1;
          }
        });
      })
      .then(() => {
        response.data = {
          cart_max_item: store.state.billing.billing.cart.hasOwnProperty(
            "cart_max_item"
          )
            ? store.state.system.settings.cart.cart_max_item
            : "30",
          product_max_qty: store.state.system.settings.cart.hasOwnProperty(
            "product_max_qty"
          )
            ? store.state.system.settings.cart.product_max_qty
            : "1500",
          bill_summary: bill_summary,
          cart_qty_total: cart_qty_total,
          carry_bag_qty_total: carry_bag_qty_total,
          bill_buster_discount: bill_buster_discount,
          discount: discount,
          order_id: "0",
          hold_bill_count: hold_bill_count,
          store_credit: "0.00",
          sub_total: sub_total,
          tax_total: tax_total,
          total: total.toFixed(2),
          data: productData,
          bags: dispCarryBags,
        };
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "cart_details",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const removeProduct = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Remove Product");
    let response = {
      data: {},
    };
    let total = 0;

    if (store.state.system.isOffline == false) {
      let onlineData = JSON.parse(data.config.data);
      db.transaction("rw", db.cart, async () => {
        if (onlineData.all == "") {
          await db.cart.get(
            { barcode: onlineData.barcode.toString() },
            async (item) => {
              await db.cart.delete(parseInt(item.id));
            }
          );
        } else if (onlineData.all == "1") {
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(onlineData.store_id),
              parseInt(onlineData.vu_id),
              parseInt(onlineData.v_id),
              parseInt(onlineData.c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .each(async (item) => {
              await db.cart.delete(item.id);
            });
        }
      });
      return Promise.resolve(response);
    }

    db.transaction("rw", db.cart, async () => {
      if (data.all == "") {
        await db.cart.delete(parseInt(data.cart_id));
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            if (
              item.manual_discount_basis != "" &&
              item.manual_discount_factor != ""
            ) {
              total += parseInt(item.subtotal);
            }
          });
        if (total != 0) {
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(data.store_id),
              parseInt(data.vu_id),
              parseInt(data.v_id),
              parseInt(data.c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .each((item) => {
              if (
                item.manual_discount_basis == "A" &&
                item.manual_discount_factor != ""
              ) {
                item.discount =
                  parseFloat(item.discount) - parseFloat(item.md_discount);
                item.md_discount = 0;
                getManualDiscountByAmount(item, total);
              }
            });
        }
      } else if (data.all == "1") {
        let deleteAll = [];
        await db.cart
          .where("user_id")
          .equals(parseInt(data.c_id))
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            deleteAll.push(item.id);
          });
        await db.cart.bulkDelete(deleteAll);
      }
      if (store.state.system.isOffline == true) {
        response.data = {
          message: "Item Removed successfully",
          status: "remove_product",
        };
      }
    })
      .then(() => {
        store.dispatch("system/log", {
          type: "remove_product",
          log: { barcode: data.barcode, all: data.all },
          response: response,
          status: "success",
        });
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "remove_product",
          log: { name: err.name, message: err.message, barcode: data.barcode },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const updateProduct = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Update Product");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }
    let cal_disc_total = 0;
    let manual_discount_applied = false;
    db.transaction("rw", db.cart, db.products, async () => {
      let mrp = "";
      if (
        data.hasOwnProperty("selected_batch_price") &&
        parseInt(data.batch_id)
      ) {
        mrp = data.selected_batch_price;
      } else if (
        data.hasOwnProperty("selected_serial_price") &&
        parseInt(data.serial_id)
      ) {
        mrp = data.selected_serial_price;
      } else {
        mrp = data.change_mrp == "" ? data.unit_mrp : data.change_mrp;
      }

      await db.cart
        .where("barcode")
        .equals(data.barcode.toString())
        .and((filter) => {
          return filter.unit_mrp == mrp;
        })
        .first()
        .then(async (item) => {
          item.qty = data.qty;
          if (data.hasOwnProperty("unit_mrp")) {
            item.subtotal = (
              parseFloat(data.qty) * parseFloat(data.unit_mrp)
            ).toFixed(2);
            item.total = (
              parseFloat(data.qty) * parseFloat(data.unit_mrp)
            ).toFixed(2);
          }
          if (
            data.hasOwnProperty("selected_batch_price") &&
            parseInt(data.batch_id) != 0
          ) {
            item.subtotal = (
              parseFloat(data.qty) * parseFloat(data.selected_batch_price)
            ).toFixed(2);
            item.total = (
              parseFloat(data.qty) * parseFloat(data.selected_batch_price)
            ).toFixed(2);
          } else if (
            data.hasOwnProperty("selected_serial_price") &&
            parseInt(data.serial_id) != 0
          ) {
            item.subtotal = (
              parseFloat(data.qty) * parseFloat(data.selected_serial_price)
            ).toFixed(2);
            item.total = (
              parseFloat(data.qty) * parseFloat(data.selected_serial_price)
            ).toFixed(2);
          } else if (data.change_mrp != "") {
            item.subtotal = (
              parseFloat(data.qty) * parseFloat(data.change_mrp)
            ).toFixed(2);
            item.total = (
              parseFloat(data.qty) * parseFloat(data.change_mrp)
            ).toFixed(2);
          }
          if (
            item.manual_discount_basis != "" &&
            item.manual_discount_factor != ""
          ) {
            manual_discount_applied = true;
          }
          let getProduct = await db.products.get({
            barcode: data.barcode.toString(),
          });
          let tax_calculation = await taxCalculation(
            getProduct.tax_details,
            item
          );
          item.tax = tax_calculation.tax;
          item.tax_data = tax_calculation;
          if (item.tax_data.tax_type == "EXC")
            item.total = (
              Math.round(100 * item.total) / 100 +
              Math.round(100 * item.tax) / 100
            ).toFixed(2);
          await db.cart.update(item.id, item);
        });

      if (manual_discount_applied == true) {
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            if (
              item.manual_discount_basis != "" &&
              item.manual_discount_factor != ""
            ) {
              cal_disc_total += parseFloat(item.subtotal);
            }
          });

        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            if (
              item.manual_discount_basis == "P" &&
              item.manual_discount_factor != ""
            ) {
              item.discount =
                parseFloat(item.discount) - parseFloat(item.md_discount);
              getManualDiscountByPercent(item);
            } else if (
              item.manual_discount_basis == "A" &&
              item.manual_discount_factor != ""
            ) {
              item.discount =
                parseFloat(item.discount) - parseFloat(item.md_discount);
              getManualDiscountByAmount(item, cal_disc_total);
            }
          });
      }

      if (store.state.system.isOffline == true) {
        response.data = {
          message: "Product quantity successfully Updated",
          status: "product_qty_update",
          total_amount: "",
          total_qty: "",
        };
      }
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "product_qty_update",
          log: { name: err.name, message: err.message, barcode: data.barcode },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const getCustomer = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Customer Information");

    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let customer = data.data.data;
      let info = {
        mobile: customer.mobile.toString(),
        first_name: customer.first_name,
        last_name: customer.last_name,
        email: customer.email,
        gender: customer.gender,
        dob: customer.dob,
        address: "",
        gst: customer.gstin,
        sync: 0,
      };

      db.transaction("rw", db.customer, async () => {
        await db.customer
          .where("mobile")
          .equals(customer.mobile.toString())
          .first(async (item) => {
            if (item == undefined) await db.customer.put(info);
          });
      });

      return Promise.resolve(response);
    }
    let info = {
      mobile: data.mobile.toString(),
      first_name: "wPos",
      last_name: "Customer",
      email: "",
      gender: "",
      dob: "",
      address: "",
      gst: "",
      sync: 0,
    };
    db.transaction("rw", db.customer, async () => {
      await db.customer
        .where("mobile")
        .equals(data.mobile.toString())
        .first()
        .then((item) => {
          if (!(item instanceof Object)) {
            db.customer.put(info);
            if (store.state.system.isOffline == true) {
              response.data = {
                address: "",
                data: {
                  mobile: data.mobile,
                  first_name: "wPos",
                  last_name: "Customer",
                  groups: ["REGULAR"],
                },
                summary: "",
                message: "Profile Data",
                status: "profile_data",
              };
            }
          } else {
            if (store.state.system.isOffline == true) {
              response.data = {
                address: {
                  address_nickname: "",
                  address2: "",
                  pincode: "",
                  city_id: "",
                  state_id: "",
                  country_id: "",
                  state_name: "",
                  city_name: "",
                  country_name: "",
                  address1: item.address,
                },
                data: {
                  c_id: item.id,
                  mobile: item.mobile,
                  first_name: item.first_name,
                  last_name: item.last_name,
                  gender: item.gender,
                  dob: item.dob,
                  email: item.email,
                  gstin: item.gst,
                  groups: ["REGULAR"],
                },
                summary: "",
                message: "Profile Data",
                status: "profile_data",
              };
            }
          }
        });
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "get_profile",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const tagCustomer = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Tag Customer");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let requestData = JSON.parse(data.config.data);
      db.transaction("rw", db.cart, db.customer, async () => {
        let count = 0;
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(requestData.store_id),
            parseInt(requestData.vu_id),
            parseInt(requestData.v_id),
            parseInt(requestData.old_c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .count((item) => {
            count = item;
          });
        if (count != 0) {
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(requestData.store_id),
              parseInt(requestData.vu_id),
              parseInt(requestData.v_id),
              parseInt(requestData.old_c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .each(async (item) => {
              await db.cart.get(
                { barcode: item.barcode, status: "process" },
                (user) => {
                  db.cart.update(user, { user_id: data.data.data.c_id });
                }
              );
            });
        }
        // let insertData = {};
        await db.customer
          .where("mobile")
          .equals(data.data.data.mobile.toString())
          .first(async (item) => {
            let insertData = {
              terminal_id: store.state.system.settings.terminal_id,
              first_name:
                data.data.data.first_name == ""
                  ? "wPos"
                  : data.data.data.first_name,
              session_id: 0,
              address: "",
              mobile: data.data.data.mobile.toString(),
              last_name:
                data.data.data.last_name == ""
                  ? "Customer"
                  : data.data.data.last_name,
              email: data.data.data.email,
              online_c_id: data.data.data.c_id,
              gender: data.data.data.gender,
              sync: 0,
              gst: data.data.data.gstin,
              dob: data.data.data.dob,
            };
            if (item == undefined) {
              await db.customer.put(insertData);
            } else {
              await db.customer.update(item.id, insertData);
            }
          });
      });
      return Promise.resolve(response);
    }

    db.transaction("rw", db.customer, db.cart, async () => {
      await db.customer
        .where("mobile")
        .equals(data.customer_mobile.toString())
        .first()
        .then(async (item) => {
          item.first_name = data.first_name;
          item.last_name = data.last_name;
          item.email = data.email;
          item.gender = data.gender;
          item.dob = data.dob;
          item.address = data.address1 + data.address2;
          item.gst = data.gstin;

          db.customer
            .where("mobile")
            .equals(data.customer_mobile.toString())
            .modify(item);

          db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(data.store_id),
              parseInt(data.vu_id),
              parseInt(data.v_id),
              parseInt(data.old_c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .modify({ user_id: item.id });

          const token = helper.makeid(60);
          if (store.state.system.isOffline == true) {
            response.data = {
              status: "login_redirect",
              message: "Login Successfully",
              data: {
                c_id: item.id,
                dob: item.dob,
                mobile: item.mobile,
                api_token: token,
                first_name: item.first_name,
                last_name: item.last_name,
                email: item.email,
                gender: item.gender,
                anniversary_date: "0000-00-00",
                gstin: item.gst,
                groups: ["REGULAR"],
              },
              customer_group_code: "REGULAR",
              address: {
                address_nickname: "Home",
                address1: item.address,
                address2: "",
                landmark: "",
                pincode: "",
                city_id: "",
                state_id: "",
                country_id: "",
                state_name: "",
                city_name: "",
                country_name: "",
              },
              group_settings: {
                items_limit_perbill: false,
                maximum_limit_perbill: 0,
                items_limit_perday: false,
                maximum_limit_perday: 0,
                value_limit_perbill: false,
                maximum_value_perbill: 0,
                value_limit_perday: false,
                maximum_value_perday: 0,
                allow_manual_discount_item_level: false,
                allow_manual_discount_bill_level: false,
                actual_maximum_limit_perday: 0,
                actual_maximum_value_perday: 0,
              },
            };
          }
        });
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "login_for_customer",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const unTagCustomer = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Untag Customer");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let requestData = JSON.parse(data.config.data);
      db.transaction("rw", db.cart, async () => {
        let count = 0;
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(requestData.store_id),
            parseInt(requestData.vu_id),
            parseInt(requestData.v_id),
            parseInt(requestData.customer_c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .count((item) => {
            count = item;
          });
        if (count != 0) {
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(requestData.store_id),
              parseInt(requestData.vu_id),
              parseInt(requestData.v_id),
              parseInt(requestData.customer_c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .each(async (item) => {
              await db.cart.get(
                { barcode: item.barcode, status: "process" },
                (item) => {
                  db.cart.update(item, { user_id: data.data.data.c_id });
                }
              );
            });
        }
      });
      return Promise.resolve(response);
    }

    db.transaction("rw", db.cart, async () => {
      await db.cart
        .where("[store_id+vu_id+v_id+user_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
          parseInt(data.customer_c_id),
        ])
        .and((filter) => {
          return filter.status == "process";
        })
        .modify({ user_id: data.dummy_c_id });
    })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "un_tag_customer",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const createOrder = (data) => {
  return new Promise((resolve, reject) => {
    if (data.transaction_sub_type != "hold") {
      helper.getInvoiceId("order_id");
    }
    console.log("[OFFLINE]: Order Created");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let requestData = JSON.parse(data.config.data);
      let type =
        requestData.transaction_sub_type == "hold" ? "hold" : "order_process";
      let session_id = 0;
      let cart_id = [];
      db.transaction(
        "rw",
        db.cart,
        db.order,
        db.invoiceId,
        db.session,
        async () => {
          await db.session
            .where("vu_id")
            .equals(parseInt(requestData.vu_id))
            .and((filter) => {
              return (
                filter.closing_balance == null && filter.closing_time == null
              );
            })
            .first((item) => {
              if (item != undefined) {
                session_id = item.id;
              }
            });
          await db.cart
            .where("[store_id+vu_id+v_id+user_id]")
            .equals([
              parseInt(requestData.store_id),
              parseInt(requestData.vu_id),
              parseInt(requestData.v_id),
              parseInt(requestData.c_id),
            ])
            .and((filter) => {
              return filter.status == "process";
            })
            .each(async (item) => {
              cart_id.push(item.id);
              await db.cart.update(item.id, { status: type });
            });

          let order_data = {
            order_id:
              type == "hold"
                ? store.state.billing.billing.order_no_hold
                : store.state.billing.billing.order_no,
            cart_id: JSON.stringify(cart_id),
            status: type == "hold" ? "hold" : "process",
            terminal_id: store.state.system.settings.terminal_id,
            sync: 1,
            session_id: session_id,
            online_order_id: data.data.data.order_id,
          };
          await db.order.put(order_data);

          let insertData = {
            order_id:
              type == "hold"
                ? store.state.billing.billing.order_no_hold
                : store.state.billing.billing.order_no,
            invoice_id: "",
            type: "online",
            v_id: requestData.v_id,
            store_id: requestData.store_id,
            vu_id: requestData.vu_id,
            date: moment(new Date()).format("YYYY-MM-DD"),
            time: moment(new Date()).format("HH:mm:ss"),
            online_order_id: data.data.data.order_id,
          };

          await db.invoiceId.put(insertData);
        }
      );
      return Promise.resolve(response);
    }

    let cart_id = [];
    let order_data = {};
    let order_id = "";
    let sub_total = 0.0;
    let total = 0.0;
    let tax_total = 0.0;
    let tax_inc = 0.0;
    // let tax_exc = 0.0;
    let items = [];
    let bill_summary = [];
    let order_qty_total = 0;
    // let total_payable = 0;
    let amount_due = 0;
    let amount_paid = 0;
    let total_payment = 0;
    let session_id = 0;
    let manual_discount = 0;

    db.transaction(
      "rw",
      db.cart,
      db.order,
      db.invoice,
      db.payment,
      db.invoiceId,
      db.session,
      async () => {
        await db.session
          .where("vu_id")
          .equals(parseInt(data.vu_id))
          .and((filter) => {
            return (
              filter.closing_balance == "" || filter.closing_balance == null
            );
          })
          .first((item) => {
            if (item != undefined) {
              session_id = item.id;
            }
          });
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            cart_id.push(item.id);
            if (data.transaction_sub_type == "hold") {
              item.status = "hold";
              item.session_id = 0;
            } else {
              item.status = "order_process";
            }
            db.cart
              .where("[store_id+vu_id+v_id+user_id]")
              .equals([
                parseInt(data.store_id),
                parseInt(data.vu_id),
                parseInt(data.v_id),
                parseInt(data.c_id),
              ])
              .modify(item);
            order_qty_total += parseFloat(item.qty);
            sub_total += parseFloat(item.subtotal);
            tax_total += parseFloat(item.tax);
            tax_inc += item.tax_data.tax_type == "INC" ? item.tax : 0;
            // tax_exc += item.tax_data.tax_type == "EXC" ? item.tax : 0;
            total += parseFloat(item.total);
            manual_discount += parseFloat(item.md_discount);

            items.push({
              p_name: item.item_name,
              qty: item.qty,
              total: item.total,
              weight_flag: item.weight_flag,
              uom: item.uom,
              barcode: item.barcode,
              discount: item.discount,
              unit_mrp: item.unit_mrp,
              subtotal: item.subtotal,
              tax: item.tax,
            });
          });

        let man_disc = {
          name: "manual_discount",
          display_text: "Manual Discount",
          item_type: "",
          value: (Math.round(100 * manual_discount) / 100).toFixed(2),
          sign: "-",
        };

        bill_summary.push(
          {
            name: "sub_total",
            display_text: "Sub Total",
            item_type: "",
            value: (
              Math.round(100 * sub_total) / 100 -
              Math.round(100 * tax_inc) / 100
            ).toFixed(2),
            sign: "",
          },
          {
            name: "tax",
            display_text: "Tax",
            item_type: "",
            value: (Math.round(100 * tax_total) / 100).toFixed(2),
            sign: "",
          },
          {
            name: "total",
            display_text: "Total",
            item_type: "",
            value: (Math.round(100 * total) / 100).toFixed(2),
            sign: "",
          }
        );

        if (manual_discount != 0) {
          bill_summary.splice(1, 0, man_disc);
        }
        order_id =
          data.transaction_sub_type == "hold"
            ? store.state.billing.billing.order_no_hold
            : store.state.billing.billing.order_no;

        if (data.transaction_sub_type != "hold") {
          let insertData = {
            order_id: store.state.billing.billing.order_no,
            invoice_id: "",
            type: "offline",
            v_id: data.v_id,
            store_id: data.store_id,
            vu_id: data.vu_id,
            date: moment(new Date()).format("YYYY-MM-DD"),
            time: moment(new Date()).format("HH:mm:ss"),
            online_order_id: 0,
          };
          await db.invoiceId.put(insertData);
        }
      }
    )
      .then(() => {
        order_data = {
          order_id: order_id,
          cart_id: JSON.stringify(cart_id),
          status: data.transaction_sub_type == "hold" ? "hold" : "process",
          terminal_id: store.state.system.settings.terminal_id,
          sync: 0,
          session_id: session_id,
          online_order_id: 0,
        };
        db.order.put(order_data);

        db.payment
          .where("order_id")
          .equals(order_id.toString())
          .each((item) => {
            total_payment += parseFloat(item.amount);
          })
          .then(() => {
            // total_payable = (
            //   parseFloat(total) - parseFloat(total_payment)
            // ).toFixed(2);
            amount_due = (
              parseFloat(total) - parseFloat(total_payment)
            ).toFixed(2);
            amount_paid = parseFloat(total_payment).toFixed(2);
          });
      })
      .then(() => {
        if (store.state.system.isOffline == true) {
          response.data = {
            status: "proceed_to_payment",
            message: "Proceed to Payment",
            allow_credit: "0",
            customer_info: {},
            data: {
              order_id: order_id,
              custom_order_id: "",
              o_id: 0,
              v_id: data.v_id,
              store_id: data.store_id,
              user_id: data.user_id,
              trans_from: "CLOUD_TAB_WEB",
              subtotal: sub_total,
              discount: "0.00",
              transaction_sub_type: "sales",
              bill_buster_discount: "0.00",
              tax: tax_total,
              total: total,
              status: "process",
              date: moment(new Date()).format("YYYY-MM-DD"),
              time: moment(new Date()).format("HH:mm:ss"),
              month: moment(new Date()).format("MM"),
              year: moment(new Date()).format("YYYY"),
              payment_type: "full",
              payment_via: "RAZOR_PAY",
              is_invoice: "0",
              vu_id: data.vu_id,
              updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              created_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              od_id: 0,
            },
            order_summary: {
              items: items,
              item_qty: order_qty_total,
              summary: bill_summary,
              total_payable: total,
              amount_due: amount_due,
              amount_paid: amount_paid,
              order_total: total,
            },
          };
        }
      })
      .then(() => {
        store.dispatch("system/log", {
          type: "process_to_payment",
          status: "success",
          log: { orderId: order_id },
          response: response,
        });
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "process_to_payment",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const savePayment = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Save Payment");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let config = JSON.parse(data.config.data);
      let order_id = data.data.data.order_id;
      let cart_id = [];
      let pay_id = [];
      db.transaction("rw", db.payment, db.cart, db.order, async () => {
        await db.payment.put({
          order_id: store.state.billing.billing.order_no,
          invoice_id: "",
          type: {
            name: config.method,
            cash_collected: config.cash_collected,
            balance_refund: config.cash_return,
          },
          amount: parseFloat(config.amount),
          online_order_id: order_id,
        });
        if (
          data.data.order_summary.total_payable == 0 &&
          !data.data.hasOwnProperty("transaction_type")
        ) {
          console.log("online bill completed");
          await db.order
            .where("online_order_id")
            .equals(order_id)
            .first(async (item) => {
              cart_id = JSON.parse(item.cart_id);
              await db.order.delete(item.id);
            });
          await db.payment
            .where("online_order_id")
            .equals(order_id)
            .each((item) => {
              pay_id.push(item.id);
            });
          await db.payment.bulkDelete(pay_id);
          await db.cart.bulkDelete(cart_id);
        }
      });
      return Promise.resolve(response);
    }

    if (data.amount > store.state.billing.billing.total_payable) {
      response.data.status = "validation";
      response.data.message = "Entered amount is greater than bill amount.";
      resolve(response);
    }

    helper.getInvoiceId("invoice_id");

    let sub_total = 0.0;
    let total = 0.0;
    let tax_total = 0.0;
    let tax_inc = 0.0;
    // let tax_exc = 0.0;
    let items = [];
    let bill_summary = [];
    let order_qty_total = 0;
    let total_payable = 0;
    let amount_due = 0;
    let amount_paid = 0;
    let manual_discount = 0;
    let total_payment = 0;
    let payment_id = [];
    let payment_mop = [];
    let isOffline = store.state.system.isOffline == true ? 0 : 1;

    db.transaction(
      "rw",
      db.order,
      db.cart,
      db.payment,
      db.invoice,
      db.invoiceId,
      async () => {
        let type = {
          name: data.method.toUpperCase(),
          cash_collected: parseFloat(data.cash_collected).toFixed(2),
          balance_refund: parseFloat(data.cash_return).toFixed(2),
        };
        await db.payment.put({
          order_id: data.order_id,
          invoice_id: "",
          type: type,
          amount: parseFloat(data.amount),
          online_order_id: 0,
        });
        await db.order
          .where("order_id")
          .equals(data.order_id.toString())
          .first()
          .then((ord) => {
            let products = JSON.parse(ord.cart_id);
            // console.log(products);
            products.map((product) => {
              db.cart.get(product, (itemDet) => {
                itemDet.weight_flag == true
                  ? (order_qty_total += 1)
                  : (order_qty_total += parseFloat(itemDet.qty));
                sub_total += parseFloat(itemDet.subtotal);
                tax_total += parseFloat(itemDet.tax);
                tax_inc += itemDet.tax_data.tax_type == "INC" ? itemDet.tax : 0;
                // tax_exc += itemDet.tax_data.tax_type == "EXC" ? itemDet.tax : 0;
                total += parseFloat(itemDet.total);
                manual_discount += parseFloat(itemDet.md_discount);
                items.push({
                  p_name: itemDet.item_name,
                  qty: itemDet.qty,
                  total: itemDet.total,
                  weight_flag: itemDet.weight_flag,
                  uom: itemDet.uom,
                  barcode: itemDet.barcode,
                  discount: itemDet.discount,
                  unit_mrp: itemDet.unit_mrp,
                  subtotal: itemDet.subtotal,
                  tax: itemDet.tax,
                });
              });
            });
          });

        await db.payment
          .where("order_id")
          .equals(data.order_id.toString())
          .each((pay) => {
            payment_id.push(pay.id);
            total_payment += parseFloat(pay.amount);
            payment_mop.push({
              name: pay.type.name.toLowerCase(),
              display_text: pay.type.name,
              item_type: "",
              value: pay.amount.toFixed(2),
              sign: "",
            });
          })
          .then(() => {
            total_payable = (
              parseFloat(total) - parseFloat(total_payment)
            ).toFixed(2);
            amount_due = (
              parseFloat(total) - parseFloat(total_payment)
            ).toFixed(2);
            amount_paid = parseFloat(total_payment).toFixed(2);
            console.log("total_payable: " + total_payable);
            console.log("amount_due: " + amount_due);
            console.log("amount_paid: " + amount_paid);
          });
      }
    )
      .then(() => {
        let man_disc = {
          name: "manual_discount",
          display_text: "Manual Discount",
          item_type: "",
          value: (Math.round(100 * manual_discount) / 100).toFixed(2),
          sign: "-",
        };

        bill_summary.push(
          {
            name: "sub_total",
            display_text: "Sub Total",
            item_type: "",
            value: (
              Math.round(100 * sub_total) / 100 -
              Math.round(100 * tax_inc) / 100
            ).toFixed(2),
            sign: "",
          },
          {
            name: "tax",
            display_text: "Tax",
            item_type: "",
            value: (Math.round(100 * tax_total) / 100).toFixed(2),
            sign: "",
          },
          {
            name: "total",
            display_text: "Total",
            item_type: "",
            value: (Math.round(100 * total) / 100).toFixed(2),
            sign: "",
          }
        );
        if (manual_discount != 0) {
          bill_summary.splice(1, 0, man_disc);
        }
        bill_summary = bill_summary.concat(payment_mop);
      })
      .then(() => {
        if (store.state.system.isOffline == true) {
          response.data = {
            status: "payment_save",
            redirect_to_qr: true,
            message: "Save Payment",
            data: {
              payment_id: 0,
              store_id: data.store_id,
              v_id: data.v_id,
              order_id: data.order_id,
              invoice_id: "",
              user_id: data.user_id,
              pay_id: "",
              amount: data.amount,
              method: data.method,
              cash_collected: null,
              cash_return: null,
              // payment_invoice_id: "",
              // bank: "",
              // wallet: "",
              // vpa: "",
              // error_description: "success",
              // status: "success",
              // payment_type: "full",
              // payment_gateway_type: "CASH",
              // payment_gateway_status: "ONLINE",
              // gateway_response:
              //   '{"paidAmount":"500","refundAmount":"250","paymentOn":"16 Dec 2019 18:38:10","paymentMethod":"cash","pgType":"CASH"}',
              date: moment(new Date()).format("YYYY-MM-DD"),
              time: moment(new Date()).format("HH:mm:ss"),
              // month: 12,
              // year: 2019,
              // deleted_at: null,
              created_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              updated_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              // payment_gateway_device_type: null
            },
            order_summary: {
              items: items,
              item_qty: order_qty_total,
              summary: bill_summary,
              total_payable: total_payable,
              amount_due: amount_due,
              amount_paid: amount_paid,
              order_total: total,
            },
            print_url:
              "https://dev.api.gozwing.com/order-receipt/970/1/1/Z2001001JCG00004",
          };
          store.dispatch("system/log", {
            type: "save_payment_method",
            log: { orderId: data.order_id, amount: parseFloat(data.amount) },
            response: response,
            status: "success",
          });
        }
      })
      .then(async () => {
        if (parseInt(total_payable) == 0) {
          let products = [];
          let productList = [];
          let invoice_number = "";
          let orderUniqueId = "";
          let invoiceProductId = [];
          // let order_number = "";
          let cust_mobile = "";

          // console.log("andar");
          await db.order
            .where("order_id")
            .equals(data.order_id.toString())
            .first()
            .then((prod) => {
              products = JSON.parse(prod.cart_id);
              db.order.update(prod.id, { status: "success" });
              orderUniqueId = prod.id;
            });
          await db.customer.get(data.c_id, (customer) => {
            let first_name =
              customer == undefined ? "wPos" : customer.first_name;
            let last_name =
              customer == undefined ? "Customer" : customer.last_name;
            response.data.data.customer_name = first_name + " " + last_name;
            response.data.data.mobile =
              customer == undefined ? "1114446669" : customer.mobile;
            cust_mobile =
              customer == undefined ? "1114446669" : customer.mobile;
            response.data.data.invoice_id = invoice_number;
            payment_id.map((payment) => {
              db.payment.update(payment, { invoice_id: invoice_number });
            });
          });
          await db.cart
            .where("id")
            .anyOf(products)
            .each((item) => {
              item.payment_id = JSON.stringify(payment_id);
              item.order_id = data.order_id;
              // item.invoice_no = data.order_id.replace("O", "Z");
              item.invoice_no = store.state.billing.billing.invoice_no;
              invoice_number = store.state.billing.billing.invoice_no;
              item.order_seq = 1;
              item.terminal_id = store.state.system.settings.terminal_id;
              item.sync = 0;
              item.is_offline = isOffline;
              delete item.status;
              delete item.id;
              _.assign(item, { cust_mobile: cust_mobile });
              productList.push(item);
              // order_number = data.order_id;
            });
          productList.map((prodList) => {
            db.invoice.put(prodList);
          });
          await db.cart.bulkDelete(products);
          await db.customer.get(data.c_id, (customer) => {
            let first_name =
              customer == undefined ? "wPos" : customer.first_name;
            let last_name =
              customer == undefined ? "Customer" : customer.last_name;
            response.data.data.customer_name = first_name + " " + last_name;
            response.data.data.mobile =
              customer == undefined ? "1114446669" : customer.mobile;
            response.data.data.invoice_id = invoice_number;
            payment_id.map((payment) => {
              db.payment.update(payment, { invoice_id: invoice_number });
            });
          });
          await db.invoice
            .where("invoice_no")
            .equals(invoice_number.toString())
            .each((invoiceitem) => {
              invoiceProductId.push(invoiceitem.id);
            });
          await db.order.update(orderUniqueId, {
            cart_id: JSON.stringify(invoiceProductId),
            bill_remark: store.state.billing.billing.remark,
          });
          await db.invoiceId.get({ order_id: data.order_id }, (item) => {
            db.invoiceId.update(item.id, { invoice_id: invoice_number });
          });
          //download invoice data locally
          helper.downloadInvoiceData(data.order_id);
          store.dispatch("system/log", {
            type: "save_payment",
            log: { orderId: data.order_id, invoiceId: invoice_number },
            response: response,
            status: "success",
          });
        }
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "save_payment",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const getCarryBags = () => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Get Carry Bags");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    let carry_bags = store.state.system.settings.cart.carry_bag.data;
    let dispCarryBags = [];
    db.transaction("rw", db.products, async () => {
      carry_bags.map((item) => {
        db.products.get({ barcode: item }, (carry_bag) => {
          if (carry_bag != undefined) {
            let carryData = {};
            carryData.Name = carry_bag.name;
            carryData.BAG_ID = carry_bag.barcode;
            carryData.Price = carry_bag.mrp;
            carryData.Qty = 0;
            dispCarryBags.push(carryData);
          }
        });
      });
    })
      .then(() => {
        if (store.state.system.isOffline == true) {
          response.data.data = dispCarryBags;
        }
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "get_carry_bags",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const saveCarryBags = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Save Carry Bags");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    let carryBags = JSON.parse(data.bags);

    carryBags.map((item) => {
      let insertData = {
        v_id: data.v_id,
        store_id: data.store_id,
        user_id: data.c_id,
        barcode: item[0],
        sku: 0,
        item_name: "",
        qty: item[1],
        unit_mrp: 0,
        unit_rsp: 0,
        subtotal: 0,
        total: 0,
        tax: 0,
        discount: 0,
        md_discount: 0,
        status: "process",
        vu_id: data.vu_id,
        date: moment(new Date()).format("YYYY-MM-DD"),
        time: moment(new Date()).format("HH:mm:ss"),
        weight_flag: false,
        tax_data: 0,
      };
      db.transaction("rw", db.cart, db.products, async () => {
        await db.products
          .where("barcode")
          .equals(item[0].toString())
          .first()
          .then(async (item) => {
            insertData.subtotal = item.mrp;
            insertData.total = item.mrp;
            insertData.sku = item.sku;
            insertData.uom = item.uom;
            insertData.item_name = item.name;
            insertData.unit_mrp = item.mrp;
            insertData.unit_rsp = item.rsp;
            insertData.weight_flag = item.weight_flag;
            const tax_calculation = await taxCalculation(
              item.tax_details,
              insertData
            );
            insertData.tax = tax_calculation.tax;
            insertData.tax_data = tax_calculation;
            if (insertData.tax_data.tax_type == "EXC")
              insertData.total = (
                Math.round(100 * insertData.total) / 100 +
                Math.round(100 * insertData.tax) / 100
              ).toFixed(2);
            await db.cart.get({ barcode: item.barcode }, (carry_bag) => {
              if (carry_bag != undefined) {
                db.cart.update(carry_bag, { qty: insertData.qty });
              } else {
                db.cart.put(insertData);
              }
            });
          });

        if (store.state.system.isOffline == true) {
          response.data = {
            message: "Carry Bags Updated",
            status: "add_to_cart",
          };
        }
      })
        .then(() => {
          resolve(response);
        })
        .catch((err) => {
          store.dispatch("system/log", {
            type: "save_carry_bags",
            log: { name: err.name, message: err.message },
            response: err.stack,
            status: "error",
          });
          alertData();
          reject(response);
        });
    });
  });
};

export const setManualDiscount = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Manual Discount");
    db.transaction("rw", db.cart, async () => {
      let total = 0;

      if (data.manual_discount_basis == "A") {
        await db.cart
          .where("[store_id+vu_id+v_id+user_id]")
          .equals([
            parseInt(data.store_id),
            parseInt(data.vu_id),
            parseInt(data.v_id),
            parseInt(data.c_id),
          ])
          .and((filter) => {
            return filter.status == "process";
          })
          .each((item) => {
            total += parseFloat(item.subtotal);
          });
      }
      await db.cart
        .where("[store_id+vu_id+v_id+user_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
          parseInt(data.c_id),
        ])
        .each(async (item) => {
          if (item.md_discount != "") {
            item.discount =
              parseFloat(item.discount) - parseFloat(item.md_discount);
          }
          if (store.state.system.isOffline == true) {
            item.manual_discount_basis = data.manual_discount_basis;
            item.manual_discount_factor = data.manual_discount_factor;
          }
          if (
            item.manual_discount_basis == "P" &&
            item.manual_discount_factor != ""
          ) {
            getManualDiscountByPercent(item);
          } else if (
            item.manual_discount_basis == "A" &&
            item.manual_discount_factor != ""
          ) {
            getManualDiscountByAmount(item, total);
          }
        });
    })
      .then(() => {
        store.dispatch("system/log", {
          type: "set_manual_discount",
          log: {
            basis: data.manual_discount_basis,
            factor: data.manual_discount_factor,
          },
          status: "success",
        });
        resolve();
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "set_manual_discount",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject();
      });
  });
};

export const removeManualDiscount = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Remove Manual Discount");
    db.transaction("rw", db.logs, db.cart, async () => {
      await db.cart
        .where("[store_id+vu_id+v_id+user_id]")
        .equals([
          parseInt(data.store_id),
          parseInt(data.vu_id),
          parseInt(data.v_id),
          parseInt(data.c_id),
        ])
        .and((filter) => {
          return filter.status == "process";
        })
        .each(async (item) => {
          if (
            item.manual_discount_basis != "" &&
            item.manual_discount_factor != ""
          ) {
            item.total = item.subtotal;
            item.manual_discount_basis = "";
            item.manual_discount_factor = "";
            item.discount = (
              parseFloat(item.discount) - parseFloat(item.md_discount)
            ).toFixed(2);
            item.md_discount = 0;
            let tax_calculation = await taxCalculation(item.tax_data, item);
            item.tax = tax_calculation.tax;
            item.tax_data = tax_calculation;
          }
          await db.cart.update(item.id, item);
        })
        .then(() => {
          store.dispatch("system/log", {
            type: "remove_manual_discount",
            log: {},
            status: "success",
            response: "",
          });
          resolve();
        })
        .catch((err) => {
          store.dispatch("system/log", {
            type: "remove_manual_discount",
            log: { name: err.name, message: err.message },
            response: err.stack,
            status: "error",
          });
          alertData();
          reject();
        });
    });
  });
};

function taxCalculation(val, data) {
  let sgst = parseFloat(val.sgst);
  let cgst = parseFloat(val.cgst);
  let igst = parseFloat(val.igst);
  let cess = parseFloat(val.cess);
  let amount = Math.round(100 * (parseFloat(data.total) / data.qty)) / 100;
  let taxable = 0.0;

  let sgst_amt = 0;
  let cgst_amt = 0;
  let igst_amt = 0;
  let cess_amt = 0;

  let final_sgst_amt = 0;
  let final_cgst_amt = 0;
  let final_igst_amt = 0;
  let final_cess_amt = 0;
  let final_taxable = 0.0;
  let final_tax = 0.0;

  let tax = 0.0;

  if (val.tax_type == "EXC") {
    cgst_amt = parseFloat(amount * cgst) / 100;
    sgst_amt = parseFloat(amount * sgst) / 100;
    cess_amt = parseFloat(amount * cess) / 100;
    igst_amt = parseFloat(amount * igst) / 100;
    tax = Math.round(100 * (cgst_amt + sgst_amt + igst_amt + cess_amt)) / 100;
    taxable = parseFloat(amount);
  } else {
    cgst_amt = (amount / (100 + cgst + sgst + cess)) * cgst;
    sgst_amt = (amount / (100 + cgst + sgst + cess)) * sgst;
    cess_amt = (amount / (100 + cgst + sgst + cess)) * cess;
    igst_amt = (amount / (100 + igst + cess)) * igst;
    tax = Math.round(100 * (cgst_amt + sgst_amt + igst_amt + cess_amt)) / 100;
    taxable = amount - parseFloat(tax);
  }

  final_sgst_amt = Math.round(100 * (sgst_amt * data.qty)) / 100;
  final_cgst_amt = Math.round(100 * (cgst_amt * data.qty)) / 100;
  final_igst_amt = Math.round(100 * (igst_amt * data.qty)) / 100;
  final_cess_amt = Math.round(100 * (cess_amt * data.qty)) / 100;
  final_tax = Math.round(100 * (tax * data.qty)) / 100;
  final_taxable = Math.round(100 * (taxable * data.qty)) / 100;

  val.cgstamt = final_cgst_amt;
  val.sgstamt = final_sgst_amt;
  val.igstamt = final_igst_amt;
  val.cessamt = final_cess_amt;
  val.taxable = final_taxable;
  val.tax = final_tax;
  val.total = val.total * data.qty;
  val.netamt = val.netamt * data.qty;

  return val;
}

function getManualDiscountByPercent(item) {
  let manual_discount = 0;
  db.transaction("rw", db.cart, async () => {
    manual_discount = (
      (parseFloat(item.subtotal) * parseFloat(item.manual_discount_factor)) /
      100
    ).toFixed(2);
    let tax_calculation = await taxCalculation(item.tax_data, item);
    item.tax = tax_calculation.tax;
    item.tax_data = tax_calculation;
    item.md_discount = manual_discount;
    if (store.state.system.isOffline == true) {
      item.total = (item.subtotal - manual_discount).toFixed(2);
      item.discount = parseFloat(
        parseFloat(item.discount) + parseFloat(manual_discount)
      ).toFixed(2);
    }
    await db.cart.update(item.id, item);
  }).catch((err) => {
    store.dispatch("system/log", {
      type: "set_manual_discount",
      log: { name: err.name, message: err.message },
      response: err.stack,
      status: "error",
    });
    alertData();
  });
}

function getManualDiscountByAmount(item, total) {
  let manual_discount = 0;
  db.transaction("rw", db.cart, async () => {
    let discpercent = (parseFloat(item.manual_discount_factor) / total) * 100;
    manual_discount = ((parseFloat(item.subtotal) * discpercent) / 100).toFixed(
      2
    );

    let tax_calculation = await taxCalculation(item.tax_data, item);
    item.tax = tax_calculation.tax;
    item.tax_data = tax_calculation;
    item.md_discount = manual_discount;
    if (store.state.system.isOffline == true) {
      item.total = (parseFloat(item.subtotal) - manual_discount).toFixed(2);
      item.discount = parseFloat(
        parseFloat(item.discount) + parseFloat(manual_discount)
      ).toFixed(2);
    }
    await db.cart.update(item.id, item);
  }).catch((err) => {
    store.dispatch("system/log", {
      type: "set_manual_discount",
      log: { name: err.name, message: err.message },
      response: err.stack,
      status: "error",
    });
    alertData();
  });
}

function alertData() {
  let alertData = {
    message: msg.INTERNAL_SERVER_ERROR,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
}
